// light library entry point.

"use strict";
module.exports = require("./src/index-light");


//////////////////
// WEBPACK FOOTER
// ./node_modules/protobufjs/light.js
// module id = 34
// module chunks = 0